module.exports = __webpack_public_path__ + "img/sx.f62df553.svg";